import { notification } from 'antd';
import actions from './actions';
import { QUERY } from './query';
import { DataService } from '../../config/dataService/dataService';

const addNotificationSuccess = () => {
  notification.success({
    message: 'Engineer Added Successfully!',
  });
};

const addNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const deleteNotificationSuccess = () => {
  notification.success({
    message: 'Engineer has been Deleted',
  });
};

const deleteNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const updateNotificationSuccess = () => {
  notification.success({
    message: 'Engineer has been updated',
  });
};

const updateNotificationError = (err) => {
  notification.error({
    message: err,
  });
};

const {
  AddBegin,
  AddSuccess,
  AddErr,

  ReadBegin,
  ReadSuccess,
  ReadErr,

  UpdateBegin,
  UpdateSuccess,
  UpdateErr,

  DeleteBegin,
  DeleteSuccess,
  DeleteErr,

  AddVendorEngBegin,
  AddVendorEngSuccess,
  AddVendorEngErr,

  ReadVendorEngBegin,
  ReadVendorEngErr,
  ReadVendorEngSuccess,
} = actions;

const DataSubmit = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(AddBegin());
      const response = await DataService.post('/auth/create-user', data);
      await dispatch(AddSuccess(response.data.data));
      addNotificationSuccess();
      callback(true);
    } catch (err) {
      await dispatch(AddErr('Something went wrong, Unable to create company.'));
      addNotificationError('Something went wrong, Unable to create company.');
    }
  };
};

const DataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(ReadBegin());
      const query = await DataService.gql(QUERY.allUser(3));
      await dispatch(ReadSuccess(query.data.data.allUserProfiles.nodes));
    } catch (err) {
      await dispatch(ReadErr(err));
    }
  };
};

const DataSearch = (searchItem) => {
  return async (dispatch) => {
    try {
      await dispatch(ReadBegin());
      if (searchItem !== '') {
        const query = await DataService.get(`/data/search/${searchItem}`);
        await dispatch(ReadSuccess(query.data.data));
      } else {
        try {
          const query = await DataService.get('/data/all');
          await dispatch(ReadSuccess(query.data.data));
        } catch (err) {
          await dispatch(ReadErr(err));
        }
      }
    } catch (err) {
      await dispatch(ReadErr(err));
    }
  };
};

const DataUpdate = (id, data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(UpdateBegin());
      await DataService.gql(QUERY.updateEngineer({ id, ...data }));
      await dispatch(UpdateSuccess());
      updateNotificationSuccess();
      callback(true);
    } catch (err) {
      await dispatch(UpdateErr(err));
      updateNotificationError(err);
    }
  };
};

const DataDelete = ({ id, getData }) => {
  return async (dispatch) => {
    try {
      await dispatch(DeleteBegin());
      const data = await DataService.gql(QUERY.updateEngineer({ id, isActive: false }));

      await dispatch(DeleteSuccess(data.data));
      await getData();
      deleteNotificationSuccess();
    } catch (err) {
      await dispatch(DeleteErr(err));
      deleteNotificationError(err);
    }
  };
};

const CreateVendorEngineer = (data, callback) => {
  return async (dispatch) => {
    try {
      await dispatch(AddVendorEngBegin());
      const query = await DataService.gql(QUERY.addEngineer(data));
      await dispatch(AddVendorEngSuccess(query.data.data));
      addNotificationSuccess();
      callback(true);
    } catch (err) {
      await dispatch(AddVendorEngErr(err));
    }
  };
};

const GetVendorEng = () => {
  return async (dispatch) => {
    try {
      await dispatch(ReadVendorEngBegin());
      const query = await DataService.gql(QUERY.allEngineers);
      await dispatch(ReadVendorEngSuccess(query.data.data.allEngineers.nodes));
    } catch (err) {
      await dispatch(ReadVendorEngErr(err));
    }
  };
};

export { DataRead, DataSearch, DataSubmit, DataDelete, DataUpdate, CreateVendorEngineer, GetVendorEng };
